<ion-tabs>
  <ion-tab-bar slot="bottom">
    @for (tab of tabs; track tab.href) {
      <ion-tab-button
          [href]="tab.href"
          [tab]="tab.name"
          layout="icon-start"
      >
        <ion-icon
            [name]="tab.icon"
            aria-hidden="true"
        />
        <ion-label i18n="{{tab.i18n}}">{{ tab.label }}</ion-label>
      </ion-tab-button>
    }
  </ion-tab-bar>
</ion-tabs>
